import { defineProviderCapability } from "./define-provider-capability";

export const doppler = defineProviderCapability("doppler", {
  runtimeConfig: {
    scope: "config",
    environments: {
      local: { mode: "managed" },
      preview: { mode: "managed" },
      production: {
        mode: "not-applicable",
        note: "Production runtime/deployment is described by production-specific capabilities.",
      },
    },
    resources: [
      {
        key: "runtime-config",
        displayLabel: "Doppler runtime config",
        kind: "doppler.config",
      },
    ],
  },
});
